export default __webpack_public_path__ + "static/media/GRT.b19c5429.jpg";